import React, {useEffect, useState} from 'react';
import FormInput from "./FormInput";
import {useTranslation} from "react-i18next";
import {getOnBoardingData} from "../services/awsHandler";

const InputFieldsSection = (props) => {
    const { values, setFieldValue, errors, touched } = props;
    const { t } = useTranslation();

    return (
        <div className="form-wrapper">
            <div className={'one-col-inputs'}>
                <FormInput label={t('businessOwnerInputTitle')}
                           type={'text'}
                           value={values.businessEmail}
                           error={touched.businessEmail && errors.businessEmail}
                           onChange={val => setFieldValue('businessEmail', val)}/>
                <FormInput label={t('appNameInputTitle')}
                           type={'text'}
                           helper={t('appNameInputPlaceholder')}
                           value={values.appName}
                           error={touched.appName && errors.appName}
                           onChange={val => setFieldValue('appName', val)}/>
                <FormInput label={t('appNameSecondInputTitle')}
                           type={'text'}
                           helper={t('appNameSecondInputPlaceholder')}
                           value={values.secondAppName}
                           error={touched.secondAppName && errors.secondAppName}
                           onChange={val => setFieldValue('secondAppName', val)}/>
                <FormInput label={t('appNameThirdInputTitle')}
                           type={'text'}
                           helper={t('appNameThirdInputPlaceholder')}
                           value={values.thirdAppName}
                           error={touched.thirdAppName && errors.thirdAppName}
                           onChange={val => setFieldValue('thirdAppName', val)}/>
            </div>
            <div className={'two-cols-inputs'}>
                <FormInput label={t('appMainColorInputTitle')} error={touched.mainColor && errors.mainColor} helper={t('appMainColorInputPlaceholder')}>
                    <div className="container-color">
                        <input
                            type="color"
                            value={values.mainColor}
                            onChange={(e) => setFieldValue('mainColor',e.target.value)}
                        />
                        <input
                            className="border-none"
                            type="text"
                            value={values.mainColor}
                            onChange={(e) => setFieldValue('mainColor',e.target.value)}
                        />
                    </div>
                </FormInput>
                <FormInput label={t('appSecondaryColorInputTitle')} error={touched.secondaryColor && errors.secondaryColor} helper={t('appSecondaryColorInputPlaceholder')}>
                    <div className="container-color">
                        <input
                            type="color"
                            value={values.secondaryColor}
                            onChange={(e) => setFieldValue('secondaryColor',e.target.value)}
                        />
                        <input
                            className="border-none"
                            type="text"
                            value={values.secondaryColor}
                            onChange={(e) => setFieldValue('secondaryColor',e.target.value)}
                        />
                    </div>
                </FormInput>
            </div>
            <div className={'one-col-inputs'}>
                <FormInput label={t('appTextColorInputTitle')} error={touched.textColor && errors.textColor}>
                    <select className="form-input-style field-control" value={values.textColor} onChange={(e) => setFieldValue('textColor', e.target.value)}>
                        <option>{t('text-color')}</option>
                        <option value="#ffffff">White - #ffffff</option>
                        <option value="#000000">Black - #000000</option>
                    </select>
                </FormInput>
            </div>
        </div>
    );
};

export default InputFieldsSection;